/*
 * @Author: your name
 * @Date: 2021-12-15 15:17:41
 * @LastEditTime: 2021-12-15 15:37:39
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \GeelyEmail_Mobile\src\store\list.js
 */
const List = {
	state: {
		comeWay: "1", //来源 1.企业微信，2.用户中心,
		selectEmaList: [], //多选的邮件列表,
		DisplayName: '收件箱',
		seachForm: {
			Flag: undefined, //带星文件 1.带 2.不带
			ParentFolderId: '0', //文件夹标识，0-默认Inbox全部
			FolderType: 0,//文件夹分类：1-收件箱；2-草稿箱；3-已发送；4-已删除；5-垃圾箱；6-收藏夹(默认100-无分类)
			2: undefined, // 是否带附件,
			FuzzyCondition: undefined, //模糊搜索
			Subject: undefined, //邮箱主题（高级搜索）
			Sender: undefined, //邮箱发送者（高级搜索）
			DisplayTo: undefined, //邮箱接收者（高级搜索）
		},
		seachId: '0' //文件夹标识，0-默认Inbox全部
	},
	mutations: {
		setComeWay(state, data) {
			sessionStorage.setItem("EamWay", data);
			state.comeWay = data;
		},
		resetSeachForm(state) {
			state.seachForm = {
				Flag: undefined, //带星文件 1.带 2.不带
				FolderType: 0,
				ParentFolderId: '0', //文件夹标识，0-默认Inbox全部
				HasAttachments: undefined, // 是否带附件,
				FuzzyCondition: undefined, //模糊搜索
				Subject: undefined, //邮箱主题（高级搜索）
				Sender: undefined, //邮箱发送者（高级搜索）
				DisplayTo: undefined, //邮箱接收者（高级搜索）
			};
		},
		setSeachForm(state, data) {
			/* 设置查询对象时， 重置在赋值 */
			this.commit("resetSeachForm");
			state.seachForm = data;
		},
		setSelectEmaList(state, data) {
			state.selectEmaList = data;
		},
		setDisplayName(state, data) {
			state.DisplayName = data
		},
		setSeachId(state, data) {
			state.seachId = data
		}
	},
	actions: {},
	modules: {},
}
export default List